"use strict";
import React from "react";
import { getCustomerNameDisplay } from "../customerNameDisplay";
const AuditBillingConfirmationButtons = React.createClass({
  render: function() {
    if (this.props.isApprovable) {
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          "data-component": "AuditBillingConfirmationButtons",
          className: "audit-billing-confirmation__approve-section"
        },
        /* @__PURE__ */ React.createElement("button", { className: "button--progress", onClick: this.props.approve }, "Save and Approve")
      );
    } else {
      return /* @__PURE__ */ React.createElement("form", { onSubmit: this.submitResolveExceptions }, /* @__PURE__ */ React.createElement("div", { className: "audit-billing-confirmation__buttons" }, /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement("h6", null, "Resolve Exceptions by:"), /* @__PURE__ */ React.createElement("div", { className: "audit-billing-confirmation__radio-button" }, /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "radio",
          id: "sendMessage",
          name: "MessageOrException",
          checked: this.props.messageOrException === "sendMessage",
          onChange: this.props.handleMessageOrException,
          value: "sendMessage"
        }
      ), /* @__PURE__ */ React.createElement("label", { htmlFor: "sendMessage" }, "Send Message")), /* @__PURE__ */ React.createElement("div", { className: "audit-billing-confirmation__radio-button" }, /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "radio",
          id: "saveException",
          name: "MessageOrException",
          checked: this.props.messageOrException === "saveException",
          onChange: this.props.handleMessageOrException,
          value: "saveException"
        }
      ), /* @__PURE__ */ React.createElement("label", { htmlFor: "saveException" }, "Save Exception"), /* @__PURE__ */ React.createElement("br", null))), /* @__PURE__ */ React.createElement("button", { onClick: this.submitResolveExceptions }, "Confirm")));
    }
  },
  submitResolveExceptions(e) {
    e.preventDefault();
    this.props.confirmMessageOrException();
  }
});
const AuditBillingConfirmation = React.createClass({
  allApprovable: function() {
    const loadShipments = this.props.load.load.tms_load_shipments;
    const approvableloadShipments = loadShipments.every(
      (loadShipment) => !!loadShipment.approvable
    );
    return this.props.carrierInvoice.approvable && approvableloadShipments;
  },
  loadShipmentText: function(loadShipment) {
    const customerName = loadShipment.customer_name ? getCustomerNameDisplay(
      loadShipment.customer_name,
      loadShipment.customer_external_id
    ) : "(Missing Customer)";
    if (loadShipment.state === "Approved") {
      return `${customerName} - Approved`;
    } else if (loadShipment.approvable) {
      return `${customerName} - Ready to Bill`;
    } else {
      return `${customerName} - Billing exceptions`;
    }
  },
  paymentText: function() {
    if (this.props.carrierInvoice.state === "partial_approved") {
      return `${this.props.carrier.name} - Approved`;
    } else if (this.props.carrierInvoice.approvable) {
      return `${this.props.carrier.name} - Ready to Pay`;
    } else {
      return `${this.props.carrier.name} - Payment exceptions`;
    }
  },
  statusTexts: function() {
    const loadShipmentTexts = this.props.load.load.tms_load_shipments.map(this.loadShipmentText).join(", ");
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("span", { className: "audit-billing-confirmation__status" }, loadShipmentTexts, ",", " "), /* @__PURE__ */ React.createElement("span", { className: "audit-billing-confirmation__status" }, this.paymentText()));
  },
  render: function() {
    const confirmMessageOrException = () => {
      if (this.props.messageOrException === "sendMessage") {
        this.props.handleSendMessage();
      } else if (this.props.messageOrException === "saveException") {
        this.props.handleSaveException();
      }
    };
    const approve = () => {
      this.props.handleApprove(this.props.payment, true);
    };
    return /* @__PURE__ */ React.createElement("div", { className: " audit-billing-confirmation" }, /* @__PURE__ */ React.createElement("div", { className: "audit-billing-confirmation__status_header" }, "Status:"), this.statusTexts(), /* @__PURE__ */ React.createElement(
      AuditBillingConfirmationButtons,
      {
        isApprovable: this.allApprovable(),
        messageOrException: this.props.messageOrException,
        handleMessageOrException: this.props.handleMessageOrException,
        confirmMessageOrException,
        approve
      }
    ));
  }
});
export default AuditBillingConfirmation;
